<template>
  <div class="getCodeBtn" @click="getPhoneCode">{{codeTxt}}</div>
</template>
<script type="text/ecmascript-6">
    export default {
      data(){
        return{
          codeTxt:'获取验证码',
          canClick:true
        }
      },
      props:['phoneNumber','type','regestNumCode'],
      methods:{
        getPhoneCode(){
          let vm = this;
          if(vm.phoneNumber.length!=11){
            vm.$message({
              message: "请输入正确的手机号",
              type: 'warning'
            });
          }else if(this.canClick){
            this.canClick = false;
            let num = 60;
            vm.ajpost('/api/common/sendSms?mobile='+vm.phoneNumber+'&useType='+vm.type,{},function (data) {
              if(data.code == 0){
                vm.se = setInterval(function () {
                  if(num !=0){
                    vm.codeTxt = `${num}s`;
                    num = num-1;
                  }else {
                    clearInterval(vm.se);
                    vm.canClick = true;
                    vm.codeTxt = '获取验证码'
                  }
                },1000)
              }else{
                vm.canClick = true;
              }
              vm.$message({
                message: data.msg,
                type: 'warning'
              });
              vm.$emit('getCode',{
                type:'phoneCode',
                code:data.msg
              });
            });

          }
        }
      },
      watch:{
        regestNumCode(){
          console.log(1)
          clearTimeout(this.se)
          this.codeTxt = '获取验证码';
          this.canClick = true;
        }
      }
    }
</script>
<style scoped lang="less">
  .getCodeBtn{
    width: 100px;
    height: 50px;
    line-height: 50px;
    border: 1px solid #2764C2;
    color: #2764C2;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    border-radius: 2px;
    display: inline-block;
    margin-left: 10px;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/phoneCode.vue